module.exports = __webpack_public_path__ + "static/media/daniel-olahh.1173550e.jpg";